// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledActionButton, StyledModal, StyledTitle, StyledForm, StyledMessage } from './ForgotPasswordModalStyles';
import { FormItem } from '@/components';
import { AuthFieldsNames, TForgotPasswordFormValues } from '@/modules/Auth/helpers/types';
import { Input } from '@/ui';
import { useGetFormValidationRules } from '@/modules/Auth';

interface IForgotPasswordModalStyles {
  isOpened: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: (values: TForgotPasswordFormValues) => void;
}

const ForgotPasswordModal = ({ isOpened, isLoading, onSubmit, onClose }: IForgotPasswordModalStyles) => {
  const { t } = useTranslation(['auth']);
  const validationRules = useGetFormValidationRules();

  return (
    <StyledModal open={isOpened} onCancel={onClose} footer={null}>
      <StyledForm onFinish={onSubmit}>
        <StyledTitle>{t('auth_forgot_password_title')}</StyledTitle>
        <FormItem
          name={AuthFieldsNames.EMAIL}
          rules={validationRules[AuthFieldsNames.EMAIL]}
          label={t('auth_email_label')}
        >
          <Input type="email" />
        </FormItem>
        <StyledMessage>{t('auth_forgot_password_message')}</StyledMessage>
        <StyledActionButton type="primary" htmlType={'submit'} loading={isLoading}>
          {t('auth_forgot_password_proceed')}
        </StyledActionButton>
      </StyledForm>
    </StyledModal>
  );
};

export default ForgotPasswordModal;
